
import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';
import { dotmapsGreen } from '@constants/colors';
import DetailsTableBlock from '@components/map/tray/entity-tabs/details/details-table-block';
import Header from '@components/map/tray/header';
import { Button, Divider } from '@mui';
import AddIcon from '@material-ui/icons/Add';
import { getTrayTop } from '@selectors/map-selector';
import { getLayers } from '@selectors/layers-selector';
import DotmapsLoader from '@shared/dotmaps-loader';
import { canEditGroups } from '@utils/permission-utils';
import { openAddToGroupTray } from '@actions/map-actions';
import './tray.scss';

const Layer = () => {
  const dispatch = useDispatch();

  const tray = useSelector(getTrayTop);
  const layers = useSelector(getLayers);

  const handleAddToGroup = useCallback((data, list) => {
    dispatch(openAddToGroupTray({
      shape: R.find(R.propEq(data.layerId, 'id'))(list).shape
    }));
  }, [dispatch]);

  const trayData = (tray.trayType === 'layer' ? tray.data : null);
  if (!trayData || R.isEmpty(trayData)) {
    return null;
  }

  if (trayData.pending) {
    return (
      <div styleName="map-tray-body-wrapper">
        <Header />
        <DotmapsLoader color={dotmapsGreen} small />;
      </div>
    );
  }

  const entity = trayData.layer;

  const getAttrs = layer => {
    const fieldList = [];
    for (const field in layer) {
      if (Object.prototype.hasOwnProperty.call(layer, field)) {
        fieldList.push(<DetailsTableBlock key={field} fields={[{label: field, value: layer[field] }]} />);
      }
    }
    return fieldList;
  };

  return (
    <div styleName="map-tray-body-wrapper">
      <Header title={entity.layerType} />
      <Divider />
      <div styleName="map-tray-body">
        <div styleName="map-tray-content">
          {getAttrs(entity)}
        </div>
      </div>
      {canEditGroups() && ['Polygon', 'MultiPolygon'].includes(R.find(R.propEq(trayData.layerId, 'id'))(layers[trayData.type].list)?.shape?.type) && (
        <div styleName="map-tray-bottom-action">
          <Button
            plain
            startIcon={<AddIcon />}
            onClick={() => handleAddToGroup(trayData, layers[trayData.type].list)}
            color="primary"
            fullWidth
          >
            ADD TO GROUP
          </Button>
        </div>
      )}
    </div>
  );
};

export default memo(Layer);
